import { AdminAppState, Page } from '../../state';
import { getPageEntry } from './get-page-entry';

export const getPage = (pageKey: string) => (state: AdminAppState): Page =>
  getPageEntry(pageKey)(state).page;
